import { render, staticRenderFns } from "./newspaperInfoList.vue?vue&type=template&id=0eb06fe9&"
import script from "./newspaperInfoList.vue?vue&type=script&lang=js&"
export * from "./newspaperInfoList.vue?vue&type=script&lang=js&"
import style0 from "./newspaperInfoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports